/* eslint-disable no-param-reassign */
/* eslint-disable import/prefer-default-export */
export const orderBy = (array, key) => {
  const compare = (a, b) => {
    if (a[key] < b[key]) {
      return -1;
    }
    if (a[key] > b[key]) {
      return 1;
    }
    return 0;
  };

  return array.sort(compare);
};

export const orderByMultiple = (array, firstKey, secondKey) => {
  const compare = (a, b) => {
    if (a[firstKey] === b[firstKey]) {
      return a[secondKey] - b[secondKey];
    }

    return a[firstKey] > b[firstKey] ? -1 : 1;
  };

  return array.sort(compare);
};

export const groupBy = (array, key) => {
  return array.reduce((groups, next) => {
    (groups[next[key]] = groups[next[key]] || []).push(next);
    return groups;
  }, {});
};

export const isLastIndex = (array, index) => {
  return index === array.length - 1;
};

